import { render, staticRenderFns } from "./PhEmpty.vue?vue&type=template&id=5705f05f&scoped=true"
import script from "./PhEmpty.vue?vue&type=script&lang=js"
export * from "./PhEmpty.vue?vue&type=script&lang=js"
import style0 from "./PhEmpty.vue?vue&type=style&index=0&id=5705f05f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705f05f",
  null
  
)

export default component.exports